/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vu Dinh Luan (vdluan@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 13 2024
 **/

import { Button, Image, Typography, Row, useModal, Column } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";
import { useSidebarActions } from "@/frameworks/core/hooks";
import { ModalID, SidebarID } from "@/frameworks/core/commons";
import { hoverScrollCss } from "@/frameworks/designStuff/utils";

import * as S from "./emotion";
import AcceptGroup from "@/assets/images/backgrounds/img_make_group_type-3.png";
import FrameFirst from "@/assets/images/backgrounds/frame-1.png";
import FrameSecond from "@/assets/images/backgrounds/frame-2.png";

const NewMemberHaveInvitation = ({ invitationType }: { invitationType: "group" | "space" }) => {
	const sidebarActions = useSidebarActions();
	const { hide } = useModal();

	const handleClick = () => {
		hide(ModalID.USER_HAVE_INVITE);
		sidebarActions.show(SidebarID.Space);
	};

	return (
		<S.ViewerWrap css={hoverScrollCss} horizonAlign="center">
			<Row css={{ width: "100%", marginRight: 24, marginTop: 60 }} horizonAlign="right">
				<Button.Icon name="Close24" size="XXXlarge" variant="text" onClick={handleClick} />
			</Row>
			<Column style={{ height: "800px", width: "100%" }} horizonAlign="center">
				<Typography
					css={{
						fontWeight: "800",
						fontSize: "64px",
						lineHeight: "76px"
					}}
					typoColor="neutral_80_100"
				>
					{invitationType === "group" ? _T("초대받은 그룹이 있네요!") : _T("초대받은 스페이스가 있네요!")}
				</Typography>
				<Image css={{ width: "500px", height: "auto" }} src={FrameFirst} />
				<Image css={{ width: "368px", height: "auto" }} src={FrameSecond} />
				<Typography
					css={{
						marginTop: 60,
						marginBottom: 32,
						"@media (max-width: 768px)": {
							marginTop: 20,
							marginBottom: 16
						}
					}}
					typoColor="neutral_80_100"
					typoSize="Head5_B"
				>
					{_T("‘확인' 버튼을 클릭한 뒤 스페이스 리스트에서 ‘초대 승인' 을 눌러주세요.")}
				</Typography>
				<S.ImagesContent horizonAlign="center">
					<Button css={{ width: 160, height: 44, borderRadius: 32 }} onClick={handleClick}>
						{_T("확인")}
					</Button>
					<Image css={{ maxWidth: 676, maxHeight: 411 }} src={AcceptGroup} />
				</S.ImagesContent>
			</Column>
		</S.ViewerWrap>
	);
};

export default NewMemberHaveInvitation;
